export default {"src":"/_next/static/media/DOCS.6641691d.svg","height":18,"width":18};